export interface DevSeedAccount {
  readonly email: string;
  readonly guid: string;
}

export const DEV_ADMIN_EMAIL = 'admin@arya-properties.test';
export const DEV_ADMIN_GUID = '00000000-0000-4000-8000-000000000901';

export const DEV_INVESTOR_EMAIL = 'investor@arya.test';
export const DEV_INVESTOR_GUID = '00000000-0000-4000-8000-000000000805';

export const DEV_FRESH_INVESTOR_EMAIL = 'fresh@arya.test';
export const DEV_FRESH_INVESTOR_GUID = '00000000-0000-4000-8000-0000000009a1';

export const DEV_ONBOARDING_INVESTOR_EMAIL = 'onboarding@arya.test';
export const DEV_ONBOARDING_INVESTOR_GUID = '00000000-0000-4000-8000-0000000009a2';

export const DEV_VERIFIED_INVESTOR_EMAIL = 'verified@arya.test';
export const DEV_VERIFIED_INVESTOR_GUID = '00000000-0000-4000-8000-0000000009a3';

export const DEV_FIU_HOLD_INVESTOR_EMAIL = 'fiu-hold@arya.test';
export const DEV_FIU_HOLD_INVESTOR_GUID = '00000000-0000-4000-8000-0000000009a4';

export const DEV_KYC_REJECTED_EMAIL = 'kyc-rejected@arya.test';
export const DEV_KYC_REJECTED_GUID = '00000000-0000-4000-8000-0000000009a5';

export const DEV_KYC_EXPIRED_EMAIL = 'kyc-expired@arya.test';
export const DEV_KYC_EXPIRED_GUID = '00000000-0000-4000-8000-0000000009a6';

export const DEV_LIMIT_REACHED_EMAIL = 'limit-reached@arya.test';
export const DEV_LIMIT_REACHED_GUID = '00000000-0000-4000-8000-0000000009a7';

export const DEV_REFLECTION_INVESTOR_EMAIL = 'reflection@arya.test';
export const DEV_REFLECTION_INVESTOR_GUID = '00000000-0000-4000-8000-0000000009a8';

export const DEV_READY_TO_VERIFY_EMAIL = 'ready@arya.test';
export const DEV_READY_TO_VERIFY_GUID = '00000000-0000-4000-8000-0000000009a9';

export const DEV_EDD_REVIEW_EMAIL = 'edd-review@arya.test';
export const DEV_EDD_REVIEW_GUID = '00000000-0000-4000-8000-0000000009b1';

export const DEV_SANCTIONS_REVIEW_EMAIL = 'sanctions-review@arya.test';
export const DEV_SANCTIONS_REVIEW_GUID = '00000000-0000-4000-8000-0000000009b2';

export const DEV_SEED_ACCOUNTS: readonly DevSeedAccount[] = [
  { email: DEV_ADMIN_EMAIL, guid: DEV_ADMIN_GUID },
  { email: DEV_INVESTOR_EMAIL, guid: DEV_INVESTOR_GUID },
  { email: DEV_FRESH_INVESTOR_EMAIL, guid: DEV_FRESH_INVESTOR_GUID },
  { email: DEV_ONBOARDING_INVESTOR_EMAIL, guid: DEV_ONBOARDING_INVESTOR_GUID },
  { email: DEV_VERIFIED_INVESTOR_EMAIL, guid: DEV_VERIFIED_INVESTOR_GUID },
  { email: DEV_FIU_HOLD_INVESTOR_EMAIL, guid: DEV_FIU_HOLD_INVESTOR_GUID },
  { email: DEV_KYC_REJECTED_EMAIL, guid: DEV_KYC_REJECTED_GUID },
  { email: DEV_KYC_EXPIRED_EMAIL, guid: DEV_KYC_EXPIRED_GUID },
  { email: DEV_LIMIT_REACHED_EMAIL, guid: DEV_LIMIT_REACHED_GUID },
  { email: DEV_REFLECTION_INVESTOR_EMAIL, guid: DEV_REFLECTION_INVESTOR_GUID },
  { email: DEV_READY_TO_VERIFY_EMAIL, guid: DEV_READY_TO_VERIFY_GUID },
  { email: DEV_EDD_REVIEW_EMAIL, guid: DEV_EDD_REVIEW_GUID },
  { email: DEV_SANCTIONS_REVIEW_EMAIL, guid: DEV_SANCTIONS_REVIEW_GUID },
];

const SEED_GUIDS: ReadonlySet<string> = new Set(DEV_SEED_ACCOUNTS.map((account) => account.guid));
const SEED_EMAILS: ReadonlySet<string> = new Set(DEV_SEED_ACCOUNTS.map((account) => account.email.toLowerCase()));

export const isDevSeedAccountGuid = (guid: string): boolean => SEED_GUIDS.has(guid);

export const isDevSeedEmail = (email: string): boolean => SEED_EMAILS.has(email.trim().toLowerCase());
